// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__3mS3r","footer":"ModalCreateQualiphyProcedure_footer__1HSIz","additionData":"ModalCreateQualiphyProcedure_additionData__18GlS"};